//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
export class SearchApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }
}

export class SearchApiClient extends SearchApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    home_Index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/search";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Returns a list of autocomplete sugestion texts as per the search term.
     * @param term (optional) Search Term
     * @param customSearchFields (optional) Optional Azure Search field names to scope the autocomplete query (e.g. Summary, Description, UnifiedTrackingId).
     * @return A list of strings
     */
    search_AutoComplete(term: string | null | undefined, customSearchFields: string[] | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Search/autocomplete?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (customSearchFields !== undefined && customSearchFields !== null)
            customSearchFields && customSearchFields.forEach(item => { url_ += "customSearchFields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_AutoComplete(_response));
        });
    }

    protected processSearch_AutoComplete(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns list of Help Request Ticket and Article items with relevance score,
    TotalCount,
    SearchPaginatedDetails (Need to pass as request parameters for pagination),
    Facets for search filters
     * @return Search result
     */
    search_Search(searchRequest: SearchRequestDto): Promise<SearchResultDto> {
        let url_ = this.baseUrl + "/Search/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_Search(_response));
        });
    }

    protected processSearch_Search(response: Response): Promise<SearchResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultDto>(null as any);
    }

    /**
     * Returns list of suggested search items with relevance score for MSX data
     * @param term (optional) Search Term
     * @param pageSize (optional) Page Size
     * @return >A list of search result document
     */
    search_SearchAll(term: string | null | undefined, pageSize: number | null | undefined): Promise<MsxSuggestResponse[]> {
        let url_ = this.baseUrl + "/Search/msxsearch?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_SearchAll(_response));
        });
    }

    protected processSearch_SearchAll(response: Response): Promise<MsxSuggestResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MsxSuggestResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MsxSuggestResponse[]>(null as any);
    }

    /**
     * Get Speech To Text Token
     * @return return authentication token
     */
    search_GetSpeechToTextToken(): Promise<SpeechToTextModel> {
        let url_ = this.baseUrl + "/Search/speechtotexttoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_GetSpeechToTextToken(_response));
        });
    }

    protected processSearch_GetSpeechToTextToken(response: Response): Promise<SpeechToTextModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpeechToTextModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpeechToTextModel>(null as any);
    }

    /**
     * Returns list of suggested search items with relevance score for MSX data
     * @param term (optional) Search Term
     * @param pageSize (optional) Page size
     * @return >A list of search result document
     */
    search_Suggest(term: string | null | undefined, pageSize: number | null | undefined): Promise<MsxSuggestResponse[]> {
        let url_ = this.baseUrl + "/Search/msxsuggest?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_Suggest(_response));
        });
    }

    protected processSearch_Suggest(response: Response): Promise<MsxSuggestResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MsxSuggestResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MsxSuggestResponse[]>(null as any);
    }

    /**
     * Returns list of suggested search items with relevance score
     * @param term (optional) Search Term
     * @param searchOption (optional) SearchOption by param Default, HelpRequest, Article
     * @param isAdminSearch (optional) Is admin search
     * @param isParentChildSearch (optional) Is the search happening from the association modal
     * @param customSearchFields (optional) Optional list of Azure Search field names to scope the query (mirrors /Search/search). When omitted, all searchable fields are queried.
     * @return >A list of search result document
     */
    search_Suggest2(term: string | null | undefined, searchOption: SearchOption | null | undefined, isAdminSearch: boolean | null | undefined, isParentChildSearch: boolean | null | undefined, customSearchFields: string[] | null | undefined): Promise<SuggestResponse[]> {
        let url_ = this.baseUrl + "/Search/suggest?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (searchOption !== undefined && searchOption !== null)
            url_ += "searchOption=" + encodeURIComponent("" + searchOption) + "&";
        if (isAdminSearch !== undefined && isAdminSearch !== null)
            url_ += "isAdminSearch=" + encodeURIComponent("" + isAdminSearch) + "&";
        if (isParentChildSearch !== undefined && isParentChildSearch !== null)
            url_ += "isParentChildSearch=" + encodeURIComponent("" + isParentChildSearch) + "&";
        if (customSearchFields !== undefined && customSearchFields !== null)
            customSearchFields && customSearchFields.forEach(item => { url_ += "customSearchFields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_Suggest2(_response));
        });
    }

    protected processSearch_Suggest2(response: Response): Promise<SuggestResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuggestResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestResponse[]>(null as any);
    }

    /**
     * downloadsearchresult
     */
    search_DownloadSearchResult(searchRequest: SearchRequestDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Search/downloadsearchresult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_DownloadSearchResult(_response));
        });
    }

    protected processSearch_DownloadSearchResult(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    search_WebSearch(term: string | null | undefined): Promise<WebSearchResponse[]> {
        let url_ = this.baseUrl + "/Search/websearch?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_WebSearch(_response));
        });
    }

    protected processSearch_WebSearch(response: Response): Promise<WebSearchResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebSearchResponse[]>(null as any);
    }

    search_SharepointSearch(term: string | null | undefined): Promise<SharepointSearchResponse[]> {
        let url_ = this.baseUrl + "/Search/sharepointsearch?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch_SharepointSearch(_response));
        });
    }

    protected processSearch_SharepointSearch(response: Response): Promise<SharepointSearchResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SharepointSearchResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SharepointSearchResponse[]>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SearchResultDto implements ISearchResultDto {
    searchPaginatedDetails?: SearchPaginatedDetailDto[] | undefined;
    searchResult?: PaginatedListOfSearchResultDocumentResponse | undefined;
    facets?: { [key: string]: FacetResultDto[]; } | undefined;
    dateRangeFacetCount?: DateRangeFacetCount | undefined;

    constructor(data?: ISearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchPaginatedDetails"])) {
                this.searchPaginatedDetails = [] as any;
                for (let item of _data["searchPaginatedDetails"])
                    this.searchPaginatedDetails!.push(SearchPaginatedDetailDto.fromJS(item));
            }
            this.searchResult = _data["searchResult"] ? PaginatedListOfSearchResultDocumentResponse.fromJS(_data["searchResult"]) : <any>undefined;
            if (_data["facets"]) {
                this.facets = {} as any;
                for (let key in _data["facets"]) {
                    if (_data["facets"].hasOwnProperty(key))
                        (<any>this.facets)![key] = _data["facets"][key] ? _data["facets"][key].map((i: any) => FacetResultDto.fromJS(i)) : [];
                }
            }
            this.dateRangeFacetCount = _data["dateRangeFacetCount"] ? DateRangeFacetCount.fromJS(_data["dateRangeFacetCount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchPaginatedDetails)) {
            data["searchPaginatedDetails"] = [];
            for (let item of this.searchPaginatedDetails)
                data["searchPaginatedDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["searchResult"] = this.searchResult ? this.searchResult.toJSON() : <any>undefined;
        if (this.facets) {
            data["facets"] = {};
            for (let key in this.facets) {
                if (this.facets.hasOwnProperty(key))
                    (<any>data["facets"])[key] = (<any>this.facets)[key];
            }
        }
        data["dateRangeFacetCount"] = this.dateRangeFacetCount ? this.dateRangeFacetCount.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchResultDto {
    searchPaginatedDetails?: SearchPaginatedDetailDto[] | undefined;
    searchResult?: PaginatedListOfSearchResultDocumentResponse | undefined;
    facets?: { [key: string]: FacetResultDto[]; } | undefined;
    dateRangeFacetCount?: DateRangeFacetCount | undefined;
}

export class SearchPaginatedDetailDto implements ISearchPaginatedDetailDto {
    totalCount?: number;
    searchOption?: SearchOption;

    constructor(data?: ISearchPaginatedDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.searchOption = _data["searchOption"];
        }
    }

    static fromJS(data: any): SearchPaginatedDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPaginatedDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["searchOption"] = this.searchOption;
        return data;
    }
}

export interface ISearchPaginatedDetailDto {
    totalCount?: number;
    searchOption?: SearchOption;
}

export enum SearchOption {
    Default = "Default",
    HelpRequest = "HelpRequest",
    Article = "Article",
}

export class PaginatedListOfSearchResultDocumentResponse implements IPaginatedListOfSearchResultDocumentResponse {
    items?: SearchResultDocumentResponse[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfSearchResultDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchResultDocumentResponse.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfSearchResultDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfSearchResultDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfSearchResultDocumentResponse {
    items?: SearchResultDocumentResponse[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SearchResultDocumentResponse implements ISearchResultDocumentResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: SearchResultDocument | undefined;

    constructor(data?: ISearchResultDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            if (_data["highlights"]) {
                this.highlights = {} as any;
                for (let key in _data["highlights"]) {
                    if (_data["highlights"].hasOwnProperty(key))
                        (<any>this.highlights)![key] = _data["highlights"][key] !== undefined ? _data["highlights"][key] : [];
                }
            }
            this.document = _data["document"] ? SearchResultDocument.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchResultDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        if (this.highlights) {
            data["highlights"] = {};
            for (let key in this.highlights) {
                if (this.highlights.hasOwnProperty(key))
                    (<any>data["highlights"])[key] = (<any>this.highlights)[key];
            }
        }
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchResultDocumentResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: SearchResultDocument | undefined;
}

export class SearchResultDocument implements ISearchResultDocument {
    id?: string | undefined;
    resultType?: ResultType;
    unifiedTrackingId?: string | undefined;
    backendId?: string | undefined;
    businessJustification?: string | undefined;
    requestType?: number;
    requestTeam?: number;
    totalDeviceCount?: number;
    totalRevenue?: number;
    customerImpacts?: CustomerImpact[] | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    discriminator?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    keyphrases?: string[] | undefined;
    isActive?: boolean | undefined;
    status?: number;
    createdBy?: User | undefined;
    modifiedBy?: User | undefined;
    attachments?: Attachment[] | undefined;
    people?: string[] | undefined;
    organizations?: string[] | undefined;
    masked_text?: string | undefined;
    translated_text?: string | undefined;
    language?: string | undefined;
    tags?: Tag[] | undefined;
    coverPhoto?: string | undefined;
    numberOfViews?: string | undefined;
    publishedOn?: Date | undefined;
    scheduledPublishOn?: Date | undefined;
    publishedBy?: User | undefined;
    shouldHideAuthorInfo?: boolean | undefined;
    articleType?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    isHidden?: boolean | undefined;
    actionRequired?: string | undefined;
    actualResolutionDate?: Date | undefined;
    additionalContactEmail?: string | undefined;
    answer?: string | undefined;
    approvedMessaging?: string | undefined;
    bugNumber?: string | undefined;
    caseCodeInvestigation?: number | undefined;
    caseCodeRequest?: number | undefined;
    closedOn?: Date | undefined;
    closingSummary?: string | undefined;
    competitiveOffering?: string | undefined;
    criticality?: number | undefined;
    cssCaseNumber?: string | undefined;
    customerConcern?: string | undefined;
    customerType?: number | undefined;
    dcfApprovedValue?: string | undefined;
    dcfJustification?: string | undefined;
    dcfSR?: string | undefined;
    pfrSubType?: number | undefined;
    dealInfluenced?: boolean | undefined;
    impactReach?: number | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    isDcfRequest?: boolean | undefined;
    designedForSurfacePossible?: string | undefined;
    primaryPartner?: string | undefined;
    priority?: number | undefined;
    priorityNumber?: number | undefined;
    productCategory?: number | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    reasonForReassignment?: number | undefined;
    requestActionTakenByCss?: string | undefined;
    serialNumbersAttached?: boolean | undefined;
    taskStatus?: number | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    additionalContact?: AdditionalContact | undefined;
    assignee?: User | undefined;
    bugInformations?: BugInformationDetail[] | undefined;
    companyInformation?: CompanyInformation | undefined;
    deviceModels?: Device[] | undefined;
    hashTags?: HashTagDetail[] | undefined;
    requestTags?: RequestTag[] | undefined;
    watchers?: User[] | undefined;
    thumbnail?: string | undefined;
    isParent?: boolean | undefined;
    parentRequestId?: string | undefined;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number | undefined;
    msxCurrentTotalDeviceCount?: number | undefined;
    whyThisDateIsImportant?: string | undefined;

    constructor(data?: ISearchResultDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resultType = _data["resultType"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.backendId = _data["backendId"];
            this.businessJustification = _data["businessJustification"];
            this.requestType = _data["requestType"];
            this.requestTeam = _data["requestTeam"];
            this.totalDeviceCount = _data["totalDeviceCount"];
            this.totalRevenue = _data["totalRevenue"];
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpact.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.discriminator = _data["discriminator"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["keyphrases"])) {
                this.keyphrases = [] as any;
                for (let item of _data["keyphrases"])
                    this.keyphrases!.push(item);
            }
            this.isActive = _data["isActive"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? User.fromJS(_data["modifiedBy"]) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(item);
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(item);
            }
            this.masked_text = _data["masked_text"];
            this.translated_text = _data["translated_text"];
            this.language = _data["language"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.coverPhoto = _data["coverPhoto"];
            this.numberOfViews = _data["numberOfViews"];
            this.publishedOn = _data["publishedOn"] ? new Date(_data["publishedOn"].toString()) : <any>undefined;
            this.scheduledPublishOn = _data["scheduledPublishOn"] ? new Date(_data["scheduledPublishOn"].toString()) : <any>undefined;
            this.publishedBy = _data["publishedBy"] ? User.fromJS(_data["publishedBy"]) : <any>undefined;
            this.shouldHideAuthorInfo = _data["shouldHideAuthorInfo"];
            this.articleType = _data["articleType"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.isHidden = _data["isHidden"];
            this.actionRequired = _data["actionRequired"];
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
            this.additionalContactEmail = _data["additionalContactEmail"];
            this.answer = _data["answer"];
            this.approvedMessaging = _data["approvedMessaging"];
            this.bugNumber = _data["bugNumber"];
            this.caseCodeInvestigation = _data["caseCodeInvestigation"];
            this.caseCodeRequest = _data["caseCodeRequest"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.closingSummary = _data["closingSummary"];
            this.competitiveOffering = _data["competitiveOffering"];
            this.criticality = _data["criticality"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.customerConcern = _data["customerConcern"];
            this.customerType = _data["customerType"];
            this.dcfApprovedValue = _data["dcfApprovedValue"];
            this.dcfJustification = _data["dcfJustification"];
            this.dcfSR = _data["dcfSR"];
            this.pfrSubType = _data["pfrSubType"];
            this.dealInfluenced = _data["dealInfluenced"];
            this.impactReach = _data["impactReach"];
            this.isBlockingSale = _data["isBlockingSale"];
            this.isDcfApproved = _data["isDcfApproved"];
            this.isDcfRequest = _data["isDcfRequest"];
            this.designedForSurfacePossible = _data["designedForSurfacePossible"];
            this.primaryPartner = _data["primaryPartner"];
            this.priority = _data["priority"];
            this.priorityNumber = _data["priorityNumber"];
            this.productCategory = _data["productCategory"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            this.reasonForReassignment = _data["reasonForReassignment"];
            this.requestActionTakenByCss = _data["requestActionTakenByCss"];
            this.serialNumbersAttached = _data["serialNumbersAttached"];
            this.taskStatus = _data["taskStatus"];
            this.whatBusinessProblemIsSolved = _data["whatBusinessProblemIsSolved"];
            this.additionalContact = _data["additionalContact"] ? AdditionalContact.fromJS(_data["additionalContact"]) : <any>undefined;
            this.assignee = _data["assignee"] ? User.fromJS(_data["assignee"]) : <any>undefined;
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformationDetail.fromJS(item));
            }
            this.companyInformation = _data["companyInformation"] ? CompanyInformation.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(Device.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDetail.fromJS(item));
            }
            if (Array.isArray(_data["requestTags"])) {
                this.requestTags = [] as any;
                for (let item of _data["requestTags"])
                    this.requestTags!.push(RequestTag.fromJS(item));
            }
            if (Array.isArray(_data["watchers"])) {
                this.watchers = [] as any;
                for (let item of _data["watchers"])
                    this.watchers!.push(User.fromJS(item));
            }
            this.thumbnail = _data["thumbnail"];
            this.isParent = _data["isParent"];
            this.parentRequestId = _data["parentRequestId"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            this.msxTotalDeviceCount = _data["msxTotalDeviceCount"];
            this.msxCurrentTotalRevenue = _data["msxCurrentTotalRevenue"];
            this.msxCurrentTotalDeviceCount = _data["msxCurrentTotalDeviceCount"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
        }
    }

    static fromJS(data: any): SearchResultDocument {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resultType"] = this.resultType;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["backendId"] = this.backendId;
        data["businessJustification"] = this.businessJustification;
        data["requestType"] = this.requestType;
        data["requestTeam"] = this.requestTeam;
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["totalRevenue"] = this.totalRevenue;
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["discriminator"] = this.discriminator;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.keyphrases)) {
            data["keyphrases"] = [];
            for (let item of this.keyphrases)
                data["keyphrases"].push(item);
        }
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item);
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item);
        }
        data["masked_text"] = this.masked_text;
        data["translated_text"] = this.translated_text;
        data["language"] = this.language;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["coverPhoto"] = this.coverPhoto;
        data["numberOfViews"] = this.numberOfViews;
        data["publishedOn"] = this.publishedOn ? this.publishedOn.toISOString() : <any>undefined;
        data["scheduledPublishOn"] = this.scheduledPublishOn ? this.scheduledPublishOn.toISOString() : <any>undefined;
        data["publishedBy"] = this.publishedBy ? this.publishedBy.toJSON() : <any>undefined;
        data["shouldHideAuthorInfo"] = this.shouldHideAuthorInfo;
        data["articleType"] = this.articleType;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["actionRequired"] = this.actionRequired;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        data["additionalContactEmail"] = this.additionalContactEmail;
        data["answer"] = this.answer;
        data["approvedMessaging"] = this.approvedMessaging;
        data["bugNumber"] = this.bugNumber;
        data["caseCodeInvestigation"] = this.caseCodeInvestigation;
        data["caseCodeRequest"] = this.caseCodeRequest;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["closingSummary"] = this.closingSummary;
        data["competitiveOffering"] = this.competitiveOffering;
        data["criticality"] = this.criticality;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["customerConcern"] = this.customerConcern;
        data["customerType"] = this.customerType;
        data["dcfApprovedValue"] = this.dcfApprovedValue;
        data["dcfJustification"] = this.dcfJustification;
        data["dcfSR"] = this.dcfSR;
        data["pfrSubType"] = this.pfrSubType;
        data["dealInfluenced"] = this.dealInfluenced;
        data["impactReach"] = this.impactReach;
        data["isBlockingSale"] = this.isBlockingSale;
        data["isDcfApproved"] = this.isDcfApproved;
        data["isDcfRequest"] = this.isDcfRequest;
        data["designedForSurfacePossible"] = this.designedForSurfacePossible;
        data["primaryPartner"] = this.primaryPartner;
        data["priority"] = this.priority;
        data["priorityNumber"] = this.priorityNumber;
        data["productCategory"] = this.productCategory;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        data["reasonForReassignment"] = this.reasonForReassignment;
        data["requestActionTakenByCss"] = this.requestActionTakenByCss;
        data["serialNumbersAttached"] = this.serialNumbersAttached;
        data["taskStatus"] = this.taskStatus;
        data["whatBusinessProblemIsSolved"] = this.whatBusinessProblemIsSolved;
        data["additionalContact"] = this.additionalContact ? this.additionalContact.toJSON() : <any>undefined;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.requestTags)) {
            data["requestTags"] = [];
            for (let item of this.requestTags)
                data["requestTags"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.watchers)) {
            data["watchers"] = [];
            for (let item of this.watchers)
                data["watchers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["thumbnail"] = this.thumbnail;
        data["isParent"] = this.isParent;
        data["parentRequestId"] = this.parentRequestId;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        data["msxTotalDeviceCount"] = this.msxTotalDeviceCount;
        data["msxCurrentTotalRevenue"] = this.msxCurrentTotalRevenue;
        data["msxCurrentTotalDeviceCount"] = this.msxCurrentTotalDeviceCount;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        return data;
    }
}

export interface ISearchResultDocument {
    id?: string | undefined;
    resultType?: ResultType;
    unifiedTrackingId?: string | undefined;
    backendId?: string | undefined;
    businessJustification?: string | undefined;
    requestType?: number;
    requestTeam?: number;
    totalDeviceCount?: number;
    totalRevenue?: number;
    customerImpacts?: CustomerImpact[] | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    discriminator?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    keyphrases?: string[] | undefined;
    isActive?: boolean | undefined;
    status?: number;
    createdBy?: User | undefined;
    modifiedBy?: User | undefined;
    attachments?: Attachment[] | undefined;
    people?: string[] | undefined;
    organizations?: string[] | undefined;
    masked_text?: string | undefined;
    translated_text?: string | undefined;
    language?: string | undefined;
    tags?: Tag[] | undefined;
    coverPhoto?: string | undefined;
    numberOfViews?: string | undefined;
    publishedOn?: Date | undefined;
    scheduledPublishOn?: Date | undefined;
    publishedBy?: User | undefined;
    shouldHideAuthorInfo?: boolean | undefined;
    articleType?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    isHidden?: boolean | undefined;
    actionRequired?: string | undefined;
    actualResolutionDate?: Date | undefined;
    additionalContactEmail?: string | undefined;
    answer?: string | undefined;
    approvedMessaging?: string | undefined;
    bugNumber?: string | undefined;
    caseCodeInvestigation?: number | undefined;
    caseCodeRequest?: number | undefined;
    closedOn?: Date | undefined;
    closingSummary?: string | undefined;
    competitiveOffering?: string | undefined;
    criticality?: number | undefined;
    cssCaseNumber?: string | undefined;
    customerConcern?: string | undefined;
    customerType?: number | undefined;
    dcfApprovedValue?: string | undefined;
    dcfJustification?: string | undefined;
    dcfSR?: string | undefined;
    pfrSubType?: number | undefined;
    dealInfluenced?: boolean | undefined;
    impactReach?: number | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    isDcfRequest?: boolean | undefined;
    designedForSurfacePossible?: string | undefined;
    primaryPartner?: string | undefined;
    priority?: number | undefined;
    priorityNumber?: number | undefined;
    productCategory?: number | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    reasonForReassignment?: number | undefined;
    requestActionTakenByCss?: string | undefined;
    serialNumbersAttached?: boolean | undefined;
    taskStatus?: number | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    additionalContact?: AdditionalContact | undefined;
    assignee?: User | undefined;
    bugInformations?: BugInformationDetail[] | undefined;
    companyInformation?: CompanyInformation | undefined;
    deviceModels?: Device[] | undefined;
    hashTags?: HashTagDetail[] | undefined;
    requestTags?: RequestTag[] | undefined;
    watchers?: User[] | undefined;
    thumbnail?: string | undefined;
    isParent?: boolean | undefined;
    parentRequestId?: string | undefined;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number | undefined;
    msxCurrentTotalDeviceCount?: number | undefined;
    whyThisDateIsImportant?: string | undefined;
}

export enum ResultType {
    Ticket = "Ticket",
    Article = "Article",
}

export class CustomerImpact implements ICustomerImpact {
    crmId?: string | undefined;
    customerImpactDescription?: string | undefined;
    customerName?: string | undefined;
    deviceCount?: number;
    opportunityId?: string | undefined;
    revenue?: number;
    tpId?: string | undefined;
    customerCountry?: CustomerCountry | undefined;
    accountId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    msxOpportunityId?: string | undefined;
    status?: string | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    addedBy?: User | undefined;
    addedOn?: Date | undefined;

    constructor(data?: ICustomerImpact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crmId = _data["crmId"];
            this.customerImpactDescription = _data["customerImpactDescription"];
            this.customerName = _data["customerName"];
            this.deviceCount = _data["deviceCount"];
            this.opportunityId = _data["opportunityId"];
            this.revenue = _data["revenue"];
            this.tpId = _data["tpId"];
            this.customerCountry = _data["customerCountry"] ? CustomerCountry.fromJS(_data["customerCountry"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.endCustomerSegment = _data["endCustomerSegment"];
            this.competitor = _data["competitor"];
            this.salesPlay = _data["salesPlay"];
            this.refreshYourDevice = _data["refreshYourDevice"];
            this.msxOpportunityId = _data["msxOpportunityId"];
            this.status = _data["status"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxRevenue = _data["msxRevenue"];
            this.msxCurrentDeviceCount = _data["msxCurrentDeviceCount"];
            this.msxCurrentRevenue = _data["msxCurrentRevenue"];
            this.msxInfoUpdatedOn = _data["msxInfoUpdatedOn"] ? new Date(_data["msxInfoUpdatedOn"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.addedBy = _data["addedBy"] ? User.fromJS(_data["addedBy"]) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerImpact {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmId"] = this.crmId;
        data["customerImpactDescription"] = this.customerImpactDescription;
        data["customerName"] = this.customerName;
        data["deviceCount"] = this.deviceCount;
        data["opportunityId"] = this.opportunityId;
        data["revenue"] = this.revenue;
        data["tpId"] = this.tpId;
        data["customerCountry"] = this.customerCountry ? this.customerCountry.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["endCustomerSegment"] = this.endCustomerSegment;
        data["competitor"] = this.competitor;
        data["salesPlay"] = this.salesPlay;
        data["refreshYourDevice"] = this.refreshYourDevice;
        data["msxOpportunityId"] = this.msxOpportunityId;
        data["status"] = this.status;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxRevenue"] = this.msxRevenue;
        data["msxCurrentDeviceCount"] = this.msxCurrentDeviceCount;
        data["msxCurrentRevenue"] = this.msxCurrentRevenue;
        data["msxInfoUpdatedOn"] = this.msxInfoUpdatedOn ? this.msxInfoUpdatedOn.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerImpact {
    crmId?: string | undefined;
    customerImpactDescription?: string | undefined;
    customerName?: string | undefined;
    deviceCount?: number;
    opportunityId?: string | undefined;
    revenue?: number;
    tpId?: string | undefined;
    customerCountry?: CustomerCountry | undefined;
    accountId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    msxOpportunityId?: string | undefined;
    status?: string | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    addedBy?: User | undefined;
    addedOn?: Date | undefined;
}

export class CustomerCountry implements ICustomerCountry {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICustomerCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerCountry {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomerCountry {
    id?: number;
    name?: string | undefined;
}

export class User implements IUser {
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUser {
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
}

export class Attachment implements IAttachment {
    url?: string | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IAttachment {
    url?: string | undefined;
}

export class Tag implements ITag {
    id?: string | undefined;
    displayName?: string | undefined;
    tagHierarchy?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.tagHierarchy = _data["tagHierarchy"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["tagHierarchy"] = this.tagHierarchy;
        return data;
    }
}

export interface ITag {
    id?: string | undefined;
    displayName?: string | undefined;
    tagHierarchy?: string | undefined;
}

export class AdditionalContact implements IAdditionalContact {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;

    constructor(data?: IAdditionalContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalShippingAddress = _data["additionalShippingAddress"];
            this.additionalEmailAddress = _data["additionalEmailAddress"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
        }
    }

    static fromJS(data: any): AdditionalContact {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalShippingAddress"] = this.additionalShippingAddress;
        data["additionalEmailAddress"] = this.additionalEmailAddress;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        return data;
    }
}

export interface IAdditionalContact {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;
}

export class BugInformationDetail implements IBugInformationDetail {
    bugInformation?: number;

    constructor(data?: IBugInformationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bugInformation = _data["bugInformation"];
        }
    }

    static fromJS(data: any): BugInformationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BugInformationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bugInformation"] = this.bugInformation;
        return data;
    }
}

export interface IBugInformationDetail {
    bugInformation?: number;
}

export class CompanyInformation implements ICompanyInformation {
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    companyRegion?: number;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    alternateContactNumber?: string | undefined;

    constructor(data?: ICompanyInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.country = _data["country"];
            this.companyRegion = _data["companyRegion"];
            this.companyContactName = _data["companyContactName"];
            this.companyFullShippingAddress = _data["companyFullShippingAddress"];
            this.alternateContactNumber = _data["alternateContactNumber"];
        }
    }

    static fromJS(data: any): CompanyInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["country"] = this.country;
        data["companyRegion"] = this.companyRegion;
        data["companyContactName"] = this.companyContactName;
        data["companyFullShippingAddress"] = this.companyFullShippingAddress;
        data["alternateContactNumber"] = this.alternateContactNumber;
        return data;
    }
}

export interface ICompanyInformation {
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    companyRegion?: number;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    alternateContactNumber?: string | undefined;
}

export class Device implements IDevice {
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    deviceModelId?: number;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.deviceCount = _data["deviceCount"];
            this.deviceModelId = _data["deviceModelId"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["deviceCount"] = this.deviceCount;
        data["deviceModelId"] = this.deviceModelId;
        return data;
    }
}

export interface IDevice {
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    deviceModelId?: number;
}

export class HashTagDetail implements IHashTagDetail {
    hashTag?: string | undefined;

    constructor(data?: IHashTagDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashTag = _data["hashTag"];
        }
    }

    static fromJS(data: any): HashTagDetail {
        data = typeof data === 'object' ? data : {};
        let result = new HashTagDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashTag"] = this.hashTag;
        return data;
    }
}

export interface IHashTagDetail {
    hashTag?: string | undefined;
}

export class RequestTag implements IRequestTag {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRequestTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RequestTag {
        data = typeof data === 'object' ? data : {};
        let result = new RequestTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRequestTag {
    id?: string;
    name?: string | undefined;
}

export class FacetResultDto implements IFacetResultDto {
    count?: number | undefined;
    value?: any | undefined;
    from?: any | undefined;
    to?: any | undefined;

    constructor(data?: IFacetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.value = _data["value"];
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): FacetResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["value"] = this.value;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IFacetResultDto {
    count?: number | undefined;
    value?: any | undefined;
    from?: any | undefined;
    to?: any | undefined;
}

export class DateRangeFacetCount implements IDateRangeFacetCount {
    today?: number;
    lastweek?: number;
    lastMonth?: number;
    lastSixMonth?: number;

    constructor(data?: IDateRangeFacetCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.today = _data["today"];
            this.lastweek = _data["lastweek"];
            this.lastMonth = _data["lastMonth"];
            this.lastSixMonth = _data["lastSixMonth"];
        }
    }

    static fromJS(data: any): DateRangeFacetCount {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeFacetCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["today"] = this.today;
        data["lastweek"] = this.lastweek;
        data["lastMonth"] = this.lastMonth;
        data["lastSixMonth"] = this.lastSixMonth;
        return data;
    }
}

export interface IDateRangeFacetCount {
    today?: number;
    lastweek?: number;
    lastMonth?: number;
    lastSixMonth?: number;
}

export class SearchRequestDto implements ISearchRequestDto {
    pageSize?: number;
    pageIndex?: number;
    searchTerm?: string | undefined;
    searchOption?: SearchOption;
    searchField?: SearchField;
    facets?: string[] | undefined;
    highlightPreTag?: string | undefined;
    highlightPostTag?: string | undefined;
    filter?: string | undefined;
    select?: string[] | undefined;
    highlightFields?: string[] | undefined;
    orderBy?: string[] | undefined;
    isDateRangeCountRequired?: boolean;
    searchPaginatedDetails?: SearchPaginatedDetailDto[] | undefined;
    isAdminSearch?: boolean;
    tagSearchType?: TagSearchType;
    customSearchFields?: string[] | undefined;

    constructor(data?: ISearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.searchTerm = _data["searchTerm"];
            this.searchOption = _data["searchOption"];
            this.searchField = _data["searchField"];
            if (Array.isArray(_data["facets"])) {
                this.facets = [] as any;
                for (let item of _data["facets"])
                    this.facets!.push(item);
            }
            this.highlightPreTag = _data["highlightPreTag"];
            this.highlightPostTag = _data["highlightPostTag"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["select"])) {
                this.select = [] as any;
                for (let item of _data["select"])
                    this.select!.push(item);
            }
            if (Array.isArray(_data["highlightFields"])) {
                this.highlightFields = [] as any;
                for (let item of _data["highlightFields"])
                    this.highlightFields!.push(item);
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(item);
            }
            this.isDateRangeCountRequired = _data["isDateRangeCountRequired"];
            if (Array.isArray(_data["searchPaginatedDetails"])) {
                this.searchPaginatedDetails = [] as any;
                for (let item of _data["searchPaginatedDetails"])
                    this.searchPaginatedDetails!.push(SearchPaginatedDetailDto.fromJS(item));
            }
            this.isAdminSearch = _data["isAdminSearch"];
            this.tagSearchType = _data["tagSearchType"];
            if (Array.isArray(_data["customSearchFields"])) {
                this.customSearchFields = [] as any;
                for (let item of _data["customSearchFields"])
                    this.customSearchFields!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["searchTerm"] = this.searchTerm;
        data["searchOption"] = this.searchOption;
        data["searchField"] = this.searchField;
        if (Array.isArray(this.facets)) {
            data["facets"] = [];
            for (let item of this.facets)
                data["facets"].push(item);
        }
        data["highlightPreTag"] = this.highlightPreTag;
        data["highlightPostTag"] = this.highlightPostTag;
        data["filter"] = this.filter;
        if (Array.isArray(this.select)) {
            data["select"] = [];
            for (let item of this.select)
                data["select"].push(item);
        }
        if (Array.isArray(this.highlightFields)) {
            data["highlightFields"] = [];
            for (let item of this.highlightFields)
                data["highlightFields"].push(item);
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item);
        }
        data["isDateRangeCountRequired"] = this.isDateRangeCountRequired;
        if (Array.isArray(this.searchPaginatedDetails)) {
            data["searchPaginatedDetails"] = [];
            for (let item of this.searchPaginatedDetails)
                data["searchPaginatedDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isAdminSearch"] = this.isAdminSearch;
        data["tagSearchType"] = this.tagSearchType;
        if (Array.isArray(this.customSearchFields)) {
            data["customSearchFields"] = [];
            for (let item of this.customSearchFields)
                data["customSearchFields"].push(item);
        }
        return data;
    }
}

export interface ISearchRequestDto {
    pageSize?: number;
    pageIndex?: number;
    searchTerm?: string | undefined;
    searchOption?: SearchOption;
    searchField?: SearchField;
    facets?: string[] | undefined;
    highlightPreTag?: string | undefined;
    highlightPostTag?: string | undefined;
    filter?: string | undefined;
    select?: string[] | undefined;
    highlightFields?: string[] | undefined;
    orderBy?: string[] | undefined;
    isDateRangeCountRequired?: boolean;
    searchPaginatedDetails?: SearchPaginatedDetailDto[] | undefined;
    isAdminSearch?: boolean;
    tagSearchType?: TagSearchType;
    customSearchFields?: string[] | undefined;
}

export enum SearchField {
    Default = "Default",
    TitleOnly = "TitleOnly",
    TitleAndDescription = "TitleAndDescription",
    Custom = "Custom",
}

export enum TagSearchType {
    Default = "Default",
    Tag = "Tag",
    HashTag = "HashTag",
}

export class MsxSuggestResponse implements IMsxSuggestResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: MsxSuggestDocument | undefined;

    constructor(data?: IMsxSuggestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            if (_data["highlights"]) {
                this.highlights = {} as any;
                for (let key in _data["highlights"]) {
                    if (_data["highlights"].hasOwnProperty(key))
                        (<any>this.highlights)![key] = _data["highlights"][key] !== undefined ? _data["highlights"][key] : [];
                }
            }
            this.document = _data["document"] ? MsxSuggestDocument.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MsxSuggestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MsxSuggestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        if (this.highlights) {
            data["highlights"] = {};
            for (let key in this.highlights) {
                if (this.highlights.hasOwnProperty(key))
                    (<any>data["highlights"])[key] = (<any>this.highlights)[key];
            }
        }
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMsxSuggestResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: MsxSuggestDocument | undefined;
}

export class MsxSuggestDocument implements IMsxSuggestDocument {
    id?: string | undefined;
    opportunityId?: string | undefined;
    opportunityNumber?: string | undefined;
    accountName?: string | undefined;
    customerAccountID?: string | undefined;
    customerTPID?: string | undefined;
    accountNumber?: string | undefined;
    industryVertical?: string | undefined;
    country?: string | undefined;
    estimatedValue?: number;
    totalDeviceCount?: number;
    tpid?: string | undefined;
    topic?: string | undefined;
    region?: string | undefined;
    parentAccountId?: string | undefined;
    salesPlay?: string | undefined;
    industry?: string | undefined;
    endCustomerSegment?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    status?: string | undefined;

    constructor(data?: IMsxSuggestDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.opportunityNumber = _data["opportunityNumber"];
            this.accountName = _data["accountName"];
            this.customerAccountID = _data["customerAccountID"];
            this.customerTPID = _data["customerTPID"];
            this.accountNumber = _data["accountNumber"];
            this.industryVertical = _data["industryVertical"];
            this.country = _data["country"];
            this.estimatedValue = _data["estimatedValue"];
            this.totalDeviceCount = _data["totalDeviceCount"];
            this.tpid = _data["tpid"];
            this.topic = _data["topic"];
            this.region = _data["region"];
            this.parentAccountId = _data["parentAccountId"];
            this.salesPlay = _data["salesPlay"];
            this.industry = _data["industry"];
            this.endCustomerSegment = _data["endCustomerSegment"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MsxSuggestDocument {
        data = typeof data === 'object' ? data : {};
        let result = new MsxSuggestDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["opportunityNumber"] = this.opportunityNumber;
        data["accountName"] = this.accountName;
        data["customerAccountID"] = this.customerAccountID;
        data["customerTPID"] = this.customerTPID;
        data["accountNumber"] = this.accountNumber;
        data["industryVertical"] = this.industryVertical;
        data["country"] = this.country;
        data["estimatedValue"] = this.estimatedValue;
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["tpid"] = this.tpid;
        data["topic"] = this.topic;
        data["region"] = this.region;
        data["parentAccountId"] = this.parentAccountId;
        data["salesPlay"] = this.salesPlay;
        data["industry"] = this.industry;
        data["endCustomerSegment"] = this.endCustomerSegment;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["status"] = this.status;
        return data;
    }
}

export interface IMsxSuggestDocument {
    id?: string | undefined;
    opportunityId?: string | undefined;
    opportunityNumber?: string | undefined;
    accountName?: string | undefined;
    customerAccountID?: string | undefined;
    customerTPID?: string | undefined;
    accountNumber?: string | undefined;
    industryVertical?: string | undefined;
    country?: string | undefined;
    estimatedValue?: number;
    totalDeviceCount?: number;
    tpid?: string | undefined;
    topic?: string | undefined;
    region?: string | undefined;
    parentAccountId?: string | undefined;
    salesPlay?: string | undefined;
    industry?: string | undefined;
    endCustomerSegment?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    status?: string | undefined;
}

export class SpeechToTextModel implements ISpeechToTextModel {
    token?: string | undefined;
    region?: string | undefined;

    constructor(data?: ISpeechToTextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): SpeechToTextModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpeechToTextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["region"] = this.region;
        return data;
    }
}

export interface ISpeechToTextModel {
    token?: string | undefined;
    region?: string | undefined;
}

export class SuggestResponse implements ISuggestResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: SuggestDocument | undefined;

    constructor(data?: ISuggestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            if (_data["highlights"]) {
                this.highlights = {} as any;
                for (let key in _data["highlights"]) {
                    if (_data["highlights"].hasOwnProperty(key))
                        (<any>this.highlights)![key] = _data["highlights"][key] !== undefined ? _data["highlights"][key] : [];
                }
            }
            this.document = _data["document"] ? SuggestDocument.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SuggestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        if (this.highlights) {
            data["highlights"] = {};
            for (let key in this.highlights) {
                if (this.highlights.hasOwnProperty(key))
                    (<any>data["highlights"])[key] = (<any>this.highlights)[key];
            }
        }
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISuggestResponse {
    score?: number | undefined;
    highlights?: { [key: string]: string[]; } | undefined;
    document?: SuggestDocument | undefined;
}

export class SuggestDocument implements ISuggestDocument {
    id?: string | undefined;
    resultType?: ResultType;
    unifiedTrackingId?: string | undefined;
    createdOn?: Date | undefined;
    discriminator?: string | undefined;
    title?: string | undefined;
    tags?: Tag[] | undefined;
    keyphrases?: string[] | undefined;
    createdBy?: User | undefined;
    publishedOn?: Date | undefined;
    publishedBy?: User | undefined;
    status?: number | undefined;
    content?: string | undefined;
    modifiedOn?: Date | undefined;
    assignee?: User | undefined;
    requestType?: number;
    requestedResolutionDate?: Date | undefined;
    totalRevenue?: number;
    isParent?: boolean | undefined;
    parentRequestId?: string | undefined;

    constructor(data?: ISuggestDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resultType = _data["resultType"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.discriminator = _data["discriminator"];
            this.title = _data["title"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            if (Array.isArray(_data["keyphrases"])) {
                this.keyphrases = [] as any;
                for (let item of _data["keyphrases"])
                    this.keyphrases!.push(item);
            }
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.publishedOn = _data["publishedOn"] ? new Date(_data["publishedOn"].toString()) : <any>undefined;
            this.publishedBy = _data["publishedBy"] ? User.fromJS(_data["publishedBy"]) : <any>undefined;
            this.status = _data["status"];
            this.content = _data["content"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.assignee = _data["assignee"] ? User.fromJS(_data["assignee"]) : <any>undefined;
            this.requestType = _data["requestType"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.totalRevenue = _data["totalRevenue"];
            this.isParent = _data["isParent"];
            this.parentRequestId = _data["parentRequestId"];
        }
    }

    static fromJS(data: any): SuggestDocument {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resultType"] = this.resultType;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["discriminator"] = this.discriminator;
        data["title"] = this.title;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.keyphrases)) {
            data["keyphrases"] = [];
            for (let item of this.keyphrases)
                data["keyphrases"].push(item);
        }
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["publishedOn"] = this.publishedOn ? this.publishedOn.toISOString() : <any>undefined;
        data["publishedBy"] = this.publishedBy ? this.publishedBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["content"] = this.content;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["requestType"] = this.requestType;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["totalRevenue"] = this.totalRevenue;
        data["isParent"] = this.isParent;
        data["parentRequestId"] = this.parentRequestId;
        return data;
    }
}

export interface ISuggestDocument {
    id?: string | undefined;
    resultType?: ResultType;
    unifiedTrackingId?: string | undefined;
    createdOn?: Date | undefined;
    discriminator?: string | undefined;
    title?: string | undefined;
    tags?: Tag[] | undefined;
    keyphrases?: string[] | undefined;
    createdBy?: User | undefined;
    publishedOn?: Date | undefined;
    publishedBy?: User | undefined;
    status?: number | undefined;
    content?: string | undefined;
    modifiedOn?: Date | undefined;
    assignee?: User | undefined;
    requestType?: number;
    requestedResolutionDate?: Date | undefined;
    totalRevenue?: number;
    isParent?: boolean | undefined;
    parentRequestId?: string | undefined;
}

export class WebSearchResponse implements IWebSearchResponse {
    displayUrl?: string | undefined;
    url?: string | undefined;
    snippet?: string | undefined;
    name?: string | undefined;

    constructor(data?: IWebSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayUrl = _data["displayUrl"];
            this.url = _data["url"];
            this.snippet = _data["snippet"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WebSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayUrl"] = this.displayUrl;
        data["url"] = this.url;
        data["snippet"] = this.snippet;
        data["name"] = this.name;
        return data;
    }
}

export interface IWebSearchResponse {
    displayUrl?: string | undefined;
    url?: string | undefined;
    snippet?: string | undefined;
    name?: string | undefined;
}

export class SharepointSearchResponse implements ISharepointSearchResponse {
    name?: string | undefined;
    url?: string | undefined;
    snippet?: string | undefined;
    size?: number;
    contentType?: string | undefined;

    constructor(data?: ISharepointSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.snippet = _data["snippet"];
            this.size = _data["size"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): SharepointSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SharepointSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["snippet"] = this.snippet;
        data["size"] = this.size;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ISharepointSearchResponse {
    name?: string | undefined;
    url?: string | undefined;
    snippet?: string | undefined;
    size?: number;
    contentType?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SearchApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSearchApiException = true;

    static isSearchApiException(obj: any): obj is SearchApiException {
        return obj.isSearchApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SearchApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}